// extracted by mini-css-extract-plugin
export default {"ClientDetail":"TaskList_ClientDetail__9h5M1","tableResponsive":"TaskList_tableResponsive__yc6o3"};